import React from 'react';
import useCallback from '@/util/hook/useCallback';
import useDispatch from '@/util/hook/useDispatch';
import useSelector from '@/util/hook/useSelector';
import { getLangOptionList } from '../../util/helper/option';
import { careOrderBabyFormUpdate, selectCareOrderBabyForm, } from '../../redux/module/careOrderBabyForm';
import View from './View';
import { POPUP_TYPE } from '../../config/popup';
export default function Controller({ popupType, setPopupType }) {
    const careOrderBabyForm = useSelector(selectCareOrderBabyForm);
    const dispatch = useDispatch();
    // event handlers
    const handleChoiceChipClick = ({ optionValue }) => {
        dispatch(careOrderBabyFormUpdate({ lang: optionValue }));
    };
    const handleForwardButtonClick = useCallback(() => {
        setPopupType(POPUP_TYPE.CLOSE);
    }, []);
    const langOptionList = getLangOptionList();
    const lang = careOrderBabyForm.lang;
    const didCompleteRequiredFormFields = !!lang;
    return (<View 
    // data
    popupType={popupType} langOptionList={langOptionList} lang={lang} isForwardButtonAvailable={didCompleteRequiredFormFields} 
    // func
    setPopupType={setPopupType} handleChoiceChipClick={handleChoiceChipClick} handleForwardButtonClick={handleForwardButtonClick}/>);
}
